import { LoadingStates } from '@pb/utils'

import getUserHasIncompleteProfile from 'helpers/getUserHasIncompleteProfile'

import { UserSettingsType } from './types'

const UserSettings: UserSettingsType = {
  showCompleteProfileReminder: getUserHasIncompleteProfile(),
  showEmailConfirmationSuccessNotification: false,
  showEmailConfirmationFailureNotification: false,
  showSettingsUpdateSuccessNotification: false,
  showSettingsUpdateFailureNotification: false,
  showSettingsDeleteFailureNotification: false,
  settingsUpdateNotificationMessage: '',
  settingsDeleteNotificationMessage: '',
  showPhoneAsAltIdAddedNotification: false,
  showPhoneAsAltIdRemovedNotification: false,
  newsLetterSubscription: false,
  isApiError: false,
  payLaterDeactivate: {
    isLoading: false,
    hasFailed: false,
  },
  changePassword: {
    isLoading: false,
    hasFailed: false,
    success: false,
  },
  updateUserDetails: {
    isLoading: false,
    hasFailed: false,
    success: false,
  },
  updateCommunityNickname: {
    status: LoadingStates.NotLoaded,
  },
  addressBook: {
    context: {},
    billingAddress: {},
    shippingAddresses: [],
    verifiedAddresses: {
      addresses: [],
      submitted: {},
    },
    status: {
      loading: false,
      success: false,
      errors: false,
    },
    cities: {},
    districts: {},
    postalCode: '',
    selectedProvince: '',
    selectedProvinceCode: '',
    selectedCity: '',
    districtsLoadingState: LoadingStates.NotLoaded,
    citiesLoadingState: LoadingStates.NotLoaded,
    postalCodeLoadingState: LoadingStates.NotLoaded,
  },
  alternativeId: {
    items: [],
    method: '',
    status: LoadingStates.NotLoaded,
    errors: [],
  },
  payments: {
    isBankFieldsPopulated: true,
    bankAccountDetail: {
      bankaccountname: '',
      BIC: '',
      IBAN: '',
      accountMiddleName: '',
      accountType: '',
      accountTypeValue: '',
      personalIdType: '',
      personalIdTypeValue: '',
      bankName: '',
      bankNameValue: '',
      branchNameValue: '',
      branchName: '',
      bankBranch: '',
      bankCode: '',
      dateOfBirth: '',
      day: '',
      month: '',
      year: '',
    },
    addNewCard: {
      status: LoadingStates.NotLoaded,
      errors: [],
    },
    paymentInfoData: [],
    paymentsLoadingState: LoadingStates.NotLoaded,
    defaultCardConfig: {
      loadingState: LoadingStates.NotLoaded,
    },
    removePaymentLoadingState: LoadingStates.NotLoaded,
    paymentsNotification: null,
    paymentCardMemberIds: [],
    showBankAccountForm: true,
    status: LoadingStates.NotLoaded,
    branchList: {},
    errors: {},
  },
}

export default UserSettings
